import Vue from 'vue'

const SET_EMPRESA_LOGADO = (state,objEmpresa) => {
	state.logado = objEmpresa
}

export{
	SET_EMPRESA_LOGADO
}
